/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React from 'react'
import View from '../atoms/View'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
import { useTranslation } from 'react-i18next'
import { Form, Field } from 'react-final-form'
import Space from '../atoms/Space'
import Text from '../atoms/TextNew'
import Input from '../atoms/Input'
import AvatarInput from '../atoms/AvatarInput'
import Button from '../atoms/Button'
import { Dealer } from 'dealer-types'
import { UPDATE_PROFILE } from 'dealer-reducers'
import ChangeRequestWaitingModal from '../atoms/ChangeRequestWaitingModal'

const SettingsProfileForm = (): JSX.Element => {
  const initialData = useSelector((state: RootReducer) => state.userDataReducer)
  const changeRequestWaiting = useSelector((state: RootReducer) => state.userDataReducer.change_request_pending)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const onSubmit = (values: Dealer): void => {
    dispatch(UPDATE_PROFILE({ dealer: { ...values } }))
  }
  return (
    <View className="mx-10">
      {changeRequestWaiting && <ChangeRequestWaitingModal />}
      <Form
        onSubmit={onSubmit}
        initialValues={initialData}
        render={({ handleSubmit }) => (
          <View>
            <Space y={8} />
            <View className="grid grid-cols-2 gap-10">
              <View className="mt-2">
                <Space y={4} />
                <Text className="ml-4 text-xl font-SemiBold">{t('profile').toUpperCase()}</Text>
                <Space y={2} />
                <View className="grid grid-cols-3 bg-white pt-6 rounded-3">
                  <Field name="avatar">
                    {({ input }) => (
                      <AvatarInput imgSrc={input.value || initialData.avatar_url} onChange={input.onChange} />
                    )}
                  </Field>
                  <View className="col-span-2 mr-8 ml-2">
                    <Field name="first_name">
                      {({ input }) => (
                        <Input
                          onChange={input.onChange}
                          label={t('profile_settings_form.name')}
                          value={input.value}
                          containerStyles={{ borderRadius: '12px', border: '1px solid #bebebe' }}
                        />
                      )}
                    </Field>
                    <Space y={4} />
                    <Field name="last_name">
                      {({ input }) => (
                        <Input
                          onChange={input.onChange}
                          label={t('profile_settings_form.last_name')}
                          value={input.value}
                          containerStyles={{ borderRadius: '12px', border: '1px solid #bebebe' }}
                        />
                      )}
                    </Field>
                    <Space y={4} />
                    <Field name="nickname">
                      {({ input }) => (
                        <Input
                          onChange={input.onChange}
                          label={t('profile_settings_form.nickname')}
                          value={input.value}
                          containerStyles={{ borderRadius: '12px', border: '1px solid #bebebe' }}
                        />
                      )}
                    </Field>
                    <Space y={4} />
                    <Field name="phone">
                      {({ input }) => (
                        <Input
                          onChange={input.onChange}
                          label={t('profile_settings_form.phone')}
                          value={input.value}
                          containerStyles={{ borderRadius: '12px', border: '1px solid #bebebe' }}
                        />
                      )}
                    </Field>
                    <Space y={4} />
                    <Field name="email">
                      {({ input }) => (
                        <Input
                          onChange={input.onChange}
                          label={t('profile_settings_form.email')}
                          value={input.value}
                          containerStyles={{ borderRadius: '12px', border: '1px solid #bebebe' }}
                        />
                      )}
                    </Field>
                    <Space y={8} />
                  </View>
                </View>
              </View>
              <View className="mt-2">
                <Space y={4} />
                <Text className="ml-4 text-xl font-SemiBold">{t('company_data').toUpperCase()}</Text>
                <Space y={2} />
                <View className="grid grid-cols-3 bg-white pt-6 rounded-3">
                  <View className="col-span-2 ml-8">
                    <Field name="company_name">
                      {({ input }) => (
                        <Input
                          onChange={input.onChange}
                          label={t('profile_settings_form.company_name')}
                          value={input.value}
                          containerStyles={{ borderRadius: '12px', border: '1px solid #bebebe' }}
                        />
                      )}
                    </Field>
                    <Space y={4} />
                    <Field name="ftin">
                      {({ input }) => (
                        <Input
                          onChange={input.onChange}
                          label={t('profile_settings_form.ftin')}
                          value={input.value}
                          containerStyles={{ borderRadius: '12px', border: '1px solid #bebebe' }}
                        />
                      )}
                    </Field>
                    <Space y={4} />
                    <Field name="street">
                      {({ input }) => (
                        <Input
                          onChange={input.onChange}
                          label={t('profile_settings_form.street')}
                          value={input.value}
                          containerStyles={{ borderRadius: '12px', border: '1px solid #bebebe' }}
                        />
                      )}
                    </Field>
                    <Space y={4} />
                    <Field name="zip_code">
                      {({ input }) => (
                        <Input
                          onChange={input.onChange}
                          label={t('profile_settings_form.zip_code')}
                          value={input.value}
                          containerStyles={{ borderRadius: '12px', border: '1px solid #bebebe' }}
                        />
                      )}
                    </Field>
                    <Space y={4} />
                    <Field name="place">
                      {({ input }) => (
                        <Input
                          onChange={input.onChange}
                          label={t('profile_settings_form.place')}
                          value={input.value}
                          containerStyles={{ borderRadius: '12px', border: '1px solid #bebebe' }}
                        />
                      )}
                    </Field>
                    <Space y={4} />
                    <Field name="iban">
                      {({ input }) => (
                        <Input
                          onChange={input.onChange}
                          label={t('profile_settings_form.iban')}
                          value={input.value}
                          containerStyles={{ borderRadius: '12px', border: '1px solid #bebebe' }}
                        />
                      )}
                    </Field>
                    <Space y={4} />
                    <Field name="bic">
                      {({ input }) => (
                        <Input
                          onChange={input.onChange}
                          label={t('profile_settings_form.bic')}
                          value={input.value}
                          containerStyles={{ borderRadius: '12px', border: '1px solid #bebebe' }}
                        />
                      )}
                    </Field>
                    <Space y={8} />
                  </View>
                </View>
              </View>
              <Space y={10} />
            </View>

            <View className="max-w-[200px] m-auto bg-white">
              <Button
                isLoading={false}
                color="groupBlue"
                onClick={() => {
                  handleSubmit()?.catch(null)
                }}>
                <Text className="text-xl text-white font-SemiBold text-center">
                  <> {t('profile_settings_form.save')}</>
                </Text>
              </Button>
            </View>
            <Space y={6} />
          </View>
        )}
      />
    </View>
  )
}

export default SettingsProfileForm
